import { API_ENDPOINTS } from "./Constants";
import { apiFetch } from "./apiHelper";

export async function getAllGenres() {
    const response = await apiFetch(API_ENDPOINTS.GENRE);
    if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || "Greška prilikom dohvaćanja žanrova");
    }
    return response.json();
}

export async function addGenre(name) {
    const response = await apiFetch(API_ENDPOINTS.GENRE, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name }),
    });
    if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || "Greška prilikom dodavanja žanra");
    }
    return response.json();
}

export async function deleteGenre(id) {
    const response = await apiFetch(`${API_ENDPOINTS.GENRE}/${id}`, {
        method: "DELETE",
        credentials: "include",
    });
    if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || "Greška prilikom brisanja žanra");
    }
    return true;
}
